document.addEventListener("DOMContentLoaded", function () {
  var videos = document.querySelectorAll(".js-br-video");

  if (!videos.length) return;

  videos.forEach(function (video) {
    video.controls = false;
    video.muted = true;

    video.addEventListener("playing", function () {
      var wrapper = video.closest(".js-br-video-wrapper");
      if (wrapper) {
        wrapper.classList.add("is-playing");
      }
    });
  });

  if (!("IntersectionObserver" in window)) {
    videos.forEach(function (video) {
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {});
      }
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;

        if (entry.isIntersecting) {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.25,
    },
  );

  videos.forEach(function (video) {
    observer.observe(video);
  });
});
